import { useEffect, useState } from 'react';
/**
 * Very much a prototype of what this could look like.
 * To extend this to other components, we should probably work with the value directly rather than the index.
 * Currently only works in QuickshopSection
 */
export function useSiteWideGender(
  defaultValue: number | null,
  tabs: { value: string; label: string }[]
): [number, React.Dispatch<React.SetStateAction<number | null>>] {
  const [currentActiveButtonIndex, setCurrentActiveButtonIndex] = useState<number | null>(defaultValue);
  useEffect(() => {
    // whenever currentActiveButtonIndex changes, update localStorage with corresponding value

    if (
      currentActiveButtonIndex !== null &&
      (tabs[currentActiveButtonIndex].value === 'For Men' || tabs[currentActiveButtonIndex].value === 'For Women')
    ) {
      localStorage.setItem('gender', tabs[currentActiveButtonIndex].value);
    }
  }, [currentActiveButtonIndex, tabs]);

  useEffect(() => {
    // on mount, look for gender in local storage and set currentActiveButtonIndex to that value
    const preselectedGender = localStorage.getItem('gender');
    if (preselectedGender) {
      const preselectedGenderIndex = tabs.findIndex((tab) => tab.value === preselectedGender);
      setCurrentActiveButtonIndex(preselectedGenderIndex === -1 ? 0 : preselectedGenderIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [currentActiveButtonIndex ?? 0, setCurrentActiveButtonIndex];
}
